<template>
  <div id="app">
    <div class="header">
      <div class="content-box">
        <div>
          <img src="./assets/logo.png" alt="" class="logo" />
          <span class="sys-name"> 北斗网格时空引擎在线平台 </span>
        </div>
        <div>
          <ul class="nav-ul">
            <!-- <li><div class="nav-name">首页</div></li>
            <li><div class="nav-name">北斗网格</div></li> -->
            <li class="product-li" :class="{ active: activeIndex == 2 }">
              <div class="nav-name">产品功能</div>
              <div class="subNav">
                <div class="subNav-content-box">
                  <div
                    class="subNav-item-box"
                    v-for="(item, index) in productData"
                    :key="index"
                  >
                    <p @click="toPage(item.index)">{{ item.name }}</p>
                    <ul>
                      <li
                        v-for="(list, i) in item.children"
                        :key="i"
                        @click="toPage(list.index)"
                      >
                        {{ list.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <!-- <li class="scenes-li">
              <div class="nav-name">场景化应用</div>
              <div class="subNav">
                <div class="subNav-content-box">
                  <div class="subNav-item-box">
                    <ul>
                      <li>低空通航</li>
                    </ul>
                  </div>
                  <div class="subNav-item-box">
                    <ul>
                      <li>智慧水利</li>
                    </ul>
                  </div>
                  <div class="subNav-item-box">
                    <ul>
                      <li>气象海洋</li>
                    </ul>
                  </div>
                </div>
              </div>
            </li> -->
            <li class="developer-li">
              <div class="nav-name" @click="toAPI">开发者中心</div>
              <!-- <div class="subNav">
                <div class="subNav-content-box">
                  <div
                    class="subNav-item-box"
                    v-for="(item, index) in developerData"
                    :key="index"
                  >
                    <p>{{ item.name }}</p>
                    <ul>
                      <li v-for="(list, i) in item.children" :key="i">
                        {{ list.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
            <li class="help-li" :class="{ active: activeIndex == 5 }">
              <div class="nav-name">帮助</div>
              <div class="subNav">
                <div class="subNav-content-box">
                  <div class="subNav-item-box" @click="toUserManual">
                    <ul>
                      <li>使用说明</li>
                    </ul>
                  </div>
                  <!-- <div class="subNav-item-box">
                    <ul>
                      <li>常见问题</li>
                    </ul>
                  </div> -->
                  <div class="subNav-item-box" @click="toOtherPage(5)">
                    <ul>
                      <li>更新日志</li>
                    </ul>
                  </div>
                  <div class="subNav-item-box" @click="toAbout">
                    <ul>
                      <li>关于</li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li class="setting-li" :class="{ active: activeIndex == 6 }">
              <div class="nav-name" @click="toOtherPage(6)">设置</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <main class="main">
      <router-view></router-view>
    </main>
    <footer class="footer">
      <span>Copyright © 2006-2022中科星图股份有限公司</span>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      productData: [
        {
          name: "全球网格绘制",
          index: "1",
          children: [
            {
              name: "二维网格绘制",
              index: "1-1",
            },
            {
              name: "三维网格绘制",
              index: "1-2",
            },
          ],
        },
        {
          name: "二维网格绘制",
          index: "2",
          children: [
            {
              name: "点标绘",
              index: "2-1",
            },
            {
              name: "线标绘",
              index: "2-2",
            },
            {
              name: "面标绘",
              index: "2-3",
            },
          ],
        },
        {
          name: "三维网格绘制",
          index: "3",
          children: [
            {
              name: "点标绘",
              index: "3-1",
            },
            {
              name: "线标绘",
              index: "3-2",
            },
            {
              name: "多边立体标绘",
              index: "3-3",
            },
          ],
        },
        {
          name: "WKT网格绘制",
          index: "4",
          children: [
            {
              name: "WKT网格绘制",
              index: "4-1",
            },
          ],
        },
        {
          name: "网格编码解码",
          index: "5",
          children: [
            {
              name: "网格编码",
              index: "5-1",
            },
            {
              name: "网格解码",
              index: "5-2",
            },
            {
              name: "编码转换",
              index: "5-3",
            },
          ],
        },
        {
          name: "二维网格临近",
          index: "6",
          children: [
            {
              name: "亲属网格查询",
              index: "6-1",
            },
            {
              name: "临近网格查询",
              index: "6-2",
            },
          ],
        },
        {
          name: "三维网格临近",
          index: "7",
          children: [
            {
              name: "亲属网格查询",
              index: "7-1",
            },
            {
              name: "临近网格查询",
              index: "7-2",
            },
          ],
        },
        {
          name: "网格集空间关系",
          index: "8",
          children: [
            {
              name: "二维空间关系",
              index: "8-1",
            },
            {
              name: "三维空间关系",
              index: "8-2",
            },
          ],
        },
        {
          name: "空间层叠分析",
          index: "9",
          children: [
            {
              name: "二维层叠分析",
              index: "9-1",
            },
            {
              name: "三维层叠分析",
              index: "9-2",
            },
          ],
        },
      ],
      developerData: [
        {
          name: "Web服务API",
          children: [
            {
              name: "全球网格绘制",
            },
            {
              name: "二维网格绘制",
            },
            {
              name: "三维网格绘制",
            },
            {
              name: "WKT网格绘制",
            },
            {
              name: "网格编码解码",
            },
            {
              name: "二维网格临近",
            },
            {
              name: "三维网格临近",
            },
            {
              name: "网格集空间关系",
            },
            {
              name: "空间层叠分析",
            },
          ],
        },
      ],
      activeIndex: 2,
    };
  },
  methods: {
    toPage(index) {
      this.activeIndex = 2;
      if (index.indexOf("-") == -1) {
        this.$router.push({ path: "/product", query: { index: index + "-1" } });
      } else {
        this.$router.push({ path: "/product", query: { index: index } });
      }
    },
    toAPI() {
      window.open("./docs/index.html", "_blank");
    },
    toOtherPage(index) {
      this.activeIndex = index;
      if (index == 6) {
        this.$router.push({ path: "/setting/baseMapSetting" });
      } else if (index == 5) {
        this.$router.push({ path: "/help/updateLogs" });
      }
    },
    toUserManual() {
      window.open(
        "./file/北斗网格时空引擎在线平台V1.0(20221120).pdf",
        "_blank"
      );
    },
    toAbout() {
      // message: h('p', null, [
      //       h('span', null, '内容可以是 '),
      //       h('i', { style: 'color: teal' }, 'VNode')
      //     ])
      const h = this.$createElement;
      this.$msgbox({
        title: "关于",
        customClass: "my-msgbox",
        message: h("p", null, [
          h("div", { style: "height: 25px;" }, ""),
          h("div", { style: "height: 35px;padding-left:70px;font-size:15px" }, [
            h("span", { style: "font-weight:bold" }, "系统名称："),
            h("span", null, "北斗网格时空引擎在线平台"),
          ]),
          h("div", { style: "height: 35px;padding-left:70px;font-size:15px" }, [
            h("span", { style: "font-weight:bold" }, "当前版本："),
            h("span", null, "V1.0"),
          ]),
          h("div", { style: "height: 35px;padding-left:70px;font-size:15px" }, [
            h("span", { style: "font-weight:bold" }, "上线时间："),
            h("span", null, "2022-12"),
          ]),
          h("div", { style: "height: 25px;" }, ""),
        ]),
        showCancelButton: false,
        showConfirmButton: false,
      });
    },
  },
  mounted() {
    let url = window.location.href;
    if (url.indexOf("product") != -1) {
      this.activeIndex = 2;
    } else if (url.indexOf("setting") != -1) {
      this.activeIndex = 6;
    } else if (url.indexOf("help") != -1) {
      this.activeIndex = 5;
    }
  },
};
</script>
<style lang="scss" scoped>
.header {
  width: 100%;
  height: 60px;
  background: #24313d;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 998;
  .content-box {
    margin: 0 50px;
    display: flex;
    justify-content: space-between;
    .logo {
      width: 108px;
      height: 36px;
      display: inline;
      vertical-align: middle;
      margin: 0 10px 6px 0;
    }
    .sys-name {
      font-size: 26px;
      font-weight: 400;
      color: #ffffff;
      font-family: "PingFangSC";
      line-height: 60px;
    }
    .nav-ul {
      & > li {
        display: inline-block;
        color: #fff;
        font-size: 16px;
        margin: 0 10px;

        .nav-name {
          line-height: 60px;
          height: 60px;
          cursor: pointer;
          padding: 0 20px;
          box-sizing: border-box;
        }
        .subNav {
          position: absolute;
          top: 60px;
          z-index: 99;
          background: rgba(36, 49, 61, 0.8);
          width: 100%;
          height: 0;
          left: 50%;
          margin-left: -50%;
          transition: height 0.3s;
          color: #fff;
          overflow: hidden;
          .subNav-content-box {
            margin: 0 100px;
            display: flex;
            justify-content: space-around;
            .subNav-item-box {
              width: 120px;
              cursor: pointer;
              margin: 20px 0;
              p {
                line-height: 40px;
                border-bottom: 1px solid #fff;
                margin-bottom: 10px;
              }
              p:hover {
                color: #00e3e4;
              }
              ul {
                li {
                  height: 30px;
                  line-height: 30px;
                  font-size: 14px;
                }
                li:hover {
                  color: #00e3e4;
                }
              }
            }
          }
        }
      }
      .scenes-li,
      .help-li,
      .setting-li {
        .subNav {
          .subNav-content-box {
            margin: 0 400px;
          }
        }
      }
      li:hover .nav-name {
        background: #161f28;
        border-bottom: 2px solid #00e3e4;
      }
      li.active .nav-name {
        background: #161f28;
        border-bottom: 2px solid #00e3e4;
      }
      .product-li:hover .subNav {
        height: 210px;
        opacity: 1;
      }
      .scenes-li:hover .subNav,
      .help-li:hover .subNav,
      .setting-li:hover .subNav {
        height: 70px;
        opacity: 1;
      }
      .developer-li:hover .subNav {
        height: 370px;
      }
    }
  }
}
.main {
  width: 100%;
  height: calc(100vh - 90px);
  box-sizing: border-box;
  margin-top: 60px;
  background: #f5f5f5;
  overflow: hidden;
}
.footer {
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  background: #1c2731;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 98;
  width: 100%;
}
</style>
